import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Label from '../atoms/text/label';
import SVGIcon from '../atoms/icons';
import Regex from '../../utils/regex';
import { EditableChangeEvent } from '../../utils/types/editable';

interface InputEmailsProps {
	name: string;
	value: string[];
	label: string;
	onChange: (e: EditableChangeEvent) => void;
}

const InputEmails = ({ name, value, label, onChange }: InputEmailsProps) => {
	const { t } = useTranslation();
	const [email, setEmail] = useState('');

	const adicionarEmail = (campo: HTMLInputElement) => {
		const emailAtual = email.trim();
		if (!emailAtual || !campo.reportValidity()) return;
		if (!value.includes(emailAtual)) {
			onChange({ target: { name, value: [...value, emailAtual] } });
		}
		setEmail('');
	};

	return (
		<div className="relative h-fit min-w-0">
			<Label htmlFor={name} className="absolute -top-2 text-xs bg-white left-3 px-1">
				{label}
			</Label>
			<div className="flex flex-wrap items-center gap-1 border border-gray-border rounded-md px-3 py-2 focus-within:border-primary">
				{value.map((item) => (
					<span key={item} className="flex items-center gap-1 bg-gray-bg px-2 rounded-lg max-w-full">
						<span className="break-all">{item}</span>
						<button
							type="button"
							aria-label={`${t('misc.remove')} ${item}`}
							className="flex items-center justify-center size-4 shrink-0 rounded-full bg-gray-border hover:opacity-70"
							onClick={() => onChange({
								target: {
									name,
									value: value.filter((emailSelecionado) => emailSelecionado !== item),
								},
							})}
						>
							<SVGIcon icon="X" className="w-2 h-auto fill-gray-label" />
						</button>
					</span>
				))}
				<input
					id={name}
					name={name}
					type="email"
					value={email}
					placeholder={label}
					className="min-w-0 flex-1 w-full outline-none"
					onChange={(e) => {
						setEmail(e.target.value);
						e.target.setCustomValidity(
							!e.target.value.trim() || Regex.Email(e.target.value.trim())
								? ''
								: t('alert.error.email')
						);
					}}
					onBlur={(e) => adicionarEmail(e.currentTarget)}
					onKeyDown={(e) => {
						if (e.key === 'Enter' && !e.nativeEvent.isComposing) {
							e.preventDefault();
							adicionarEmail(e.currentTarget);
						}
					}}
				/>
			</div>
		</div>
	);
};

export default InputEmails;
